"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Notifications Macroservice
 * A collection of services related to Notifications.  Includes send services (for outbound transactional notifications), and webhooks (for inbound updates related to previously sent notifications).    Future enhancements include support for outbound marketing emails and additional channels, like SMS.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var NotificationsApi = /** @class */ (function (_super) {
    __extends(NotificationsApi, _super);
    function NotificationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns all opt-out records for the given email address and organization.
     */
    NotificationsApi.prototype.getAllOptOutsForEmailRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['organizationId'] == null) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling getAllOptOutsForEmail().');
                        }
                        if (requestParameters['emailAddress'] == null) {
                            throw new runtime.RequiredError('emailAddress', 'Required parameter "emailAddress" was null or undefined when calling getAllOptOutsForEmail().');
                        }
                        if (requestParameters['sig'] == null) {
                            throw new runtime.RequiredError('sig', 'Required parameter "sig" was null or undefined when calling getAllOptOutsForEmail().');
                        }
                        queryParameters = {};
                        if (requestParameters['sig'] != null) {
                            queryParameters['sig'] = requestParameters['sig'];
                        }
                        if (requestParameters['classification'] != null) {
                            queryParameters['classification'] = requestParameters['classification'];
                        }
                        if (requestParameters['channel'] != null) {
                            queryParameters['channel'] = requestParameters['channel'];
                        }
                        if (requestParameters['notificationIdentifier'] != null) {
                            queryParameters['notificationIdentifier'] = requestParameters['notificationIdentifier'];
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/organization/{organizationId}/optOuts/email/{emailAddress}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters['organizationId']))).replace("{".concat("emailAddress", "}"), encodeURIComponent(String(requestParameters['emailAddress']))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(index_1.NotificationOptOutShowDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns all opt-out records for the given email address and organization.
     */
    NotificationsApi.prototype.getAllOptOutsForEmail = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllOptOutsForEmailRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets all preferences for a given organization.  Returns defaults if they have not been customized.
     */
    NotificationsApi.prototype.getAllOutboundPreferencesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['organizationId'] == null) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling getAllOutboundPreferences().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/outboundPreferences/organization/{organizationId}/templates".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters['organizationId']))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(index_1.OutboundNotificationPreferencesShowDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Gets all preferences for a given organization.  Returns defaults if they have not been customized.
     */
    NotificationsApi.prototype.getAllOutboundPreferences = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllOutboundPreferencesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets preferences for a given organization, template key and channel.  Returns defaults if they haven\'t been customized.
     */
    NotificationsApi.prototype.getOutboundPreferencesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['organizationId'] == null) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling getOutboundPreferences().');
                        }
                        if (requestParameters['templateKey'] == null) {
                            throw new runtime.RequiredError('templateKey', 'Required parameter "templateKey" was null or undefined when calling getOutboundPreferences().');
                        }
                        if (requestParameters['channel'] == null) {
                            throw new runtime.RequiredError('channel', 'Required parameter "channel" was null or undefined when calling getOutboundPreferences().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/outboundPreferences/organization/{organizationId}/templates/{templateKey}/channels/{channel}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters['organizationId']))).replace("{".concat("templateKey", "}"), encodeURIComponent(String(requestParameters['templateKey']))).replace("{".concat("channel", "}"), encodeURIComponent(String(requestParameters['channel']))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.OutboundNotificationPreferencesShowDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets preferences for a given organization, template key and channel.  Returns defaults if they haven\'t been customized.
     */
    NotificationsApi.prototype.getOutboundPreferences = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOutboundPreferencesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets preferences history for a given organization, template key and channel.  Includes deleted preferences.  Does not return defaults.
     */
    NotificationsApi.prototype.getOutboundPreferencesHistoryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['organizationId'] == null) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling getOutboundPreferencesHistory().');
                        }
                        if (requestParameters['templateKey'] == null) {
                            throw new runtime.RequiredError('templateKey', 'Required parameter "templateKey" was null or undefined when calling getOutboundPreferencesHistory().');
                        }
                        if (requestParameters['channel'] == null) {
                            throw new runtime.RequiredError('channel', 'Required parameter "channel" was null or undefined when calling getOutboundPreferencesHistory().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/outboundPreferences/organization/{organizationId}/templates/{templateKey}/channels/{channel}/history".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters['organizationId']))).replace("{".concat("templateKey", "}"), encodeURIComponent(String(requestParameters['templateKey']))).replace("{".concat("channel", "}"), encodeURIComponent(String(requestParameters['channel']))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(index_1.OutboundNotificationPreferencesShowDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Gets preferences history for a given organization, template key and channel.  Includes deleted preferences.  Does not return defaults.
     */
    NotificationsApi.prototype.getOutboundPreferencesHistory = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOutboundPreferencesHistoryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Reverts preferences (to the default org preferences) for a given organization, template key, and channel.
     */
    NotificationsApi.prototype.revertOutboundPreferencesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['organizationId'] == null) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling revertOutboundPreferences().');
                        }
                        if (requestParameters['preferencesId'] == null) {
                            throw new runtime.RequiredError('preferencesId', 'Required parameter "preferencesId" was null or undefined when calling revertOutboundPreferences().');
                        }
                        if (requestParameters['outboundNotificationPreferencesUpdateDto'] == null) {
                            throw new runtime.RequiredError('outboundNotificationPreferencesUpdateDto', 'Required parameter "outboundNotificationPreferencesUpdateDto" was null or undefined when calling revertOutboundPreferences().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/outboundPreferences/organization/{organizationId}/preferences/{preferencesId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters['organizationId']))).replace("{".concat("preferencesId", "}"), encodeURIComponent(String(requestParameters['preferencesId']))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.OutboundNotificationPreferencesUpdateDtoToJSON)(requestParameters['outboundNotificationPreferencesUpdateDto']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.OutboundNotificationPreferencesShowDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Reverts preferences (to the default org preferences) for a given organization, template key, and channel.
     */
    NotificationsApi.prototype.revertOutboundPreferences = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.revertOutboundPreferencesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Send a manual (ie. user-initiated) notification (eg. \"Urgent Update on facility\" to event participants).      These may be self-certified as transactional or commercial.
     */
    NotificationsApi.prototype.sendManualRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['notificationCreateDto'] == null) {
                            throw new runtime.RequiredError('notificationCreateDto', 'Required parameter "notificationCreateDto" was null or undefined when calling sendManual().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/sendService/sendManual",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.NotificationCreateDtoToJSON)(requestParameters['notificationCreateDto']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.SendResultDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Send a manual (ie. user-initiated) notification (eg. \"Urgent Update on facility\" to event participants).      These may be self-certified as transactional or commercial.
     */
    NotificationsApi.prototype.sendManual = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendManualRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Send a transactional notification from the system (eg. \"Password Reset\" emails).
     */
    NotificationsApi.prototype.sendTransactionalRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['notificationCreateDto'] == null) {
                            throw new runtime.RequiredError('notificationCreateDto', 'Required parameter "notificationCreateDto" was null or undefined when calling sendTransactional().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/sendService/sendTransactional",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.NotificationCreateDtoToJSON)(requestParameters['notificationCreateDto']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.SendResultDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Send a transactional notification from the system (eg. \"Password Reset\" emails).
     */
    NotificationsApi.prototype.sendTransactional = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendTransactionalRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates opt out for a given user and organization.
     */
    NotificationsApi.prototype.setOptOutRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['organizationId'] == null) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling setOptOut().');
                        }
                        if (requestParameters['emailAddress'] == null) {
                            throw new runtime.RequiredError('emailAddress', 'Required parameter "emailAddress" was null or undefined when calling setOptOut().');
                        }
                        if (requestParameters['sig'] == null) {
                            throw new runtime.RequiredError('sig', 'Required parameter "sig" was null or undefined when calling setOptOut().');
                        }
                        if (requestParameters['notificationOptOutUpdateDto'] == null) {
                            throw new runtime.RequiredError('notificationOptOutUpdateDto', 'Required parameter "notificationOptOutUpdateDto" was null or undefined when calling setOptOut().');
                        }
                        queryParameters = {};
                        if (requestParameters['sig'] != null) {
                            queryParameters['sig'] = requestParameters['sig'];
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/organization/{organizationId}/optOuts/email/{emailAddress}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters['organizationId']))).replace("{".concat("emailAddress", "}"), encodeURIComponent(String(requestParameters['emailAddress']))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.NotificationOptOutUpdateDtoToJSON)(requestParameters['notificationOptOutUpdateDto']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.NotificationOptOutShowDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates opt out for a given user and organization.
     */
    NotificationsApi.prototype.setOptOut = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setOptOutRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates preferences for a given organization, template key, and channel.
     */
    NotificationsApi.prototype.updateOutboundPreferencesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['organizationId'] == null) {
                            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling updateOutboundPreferences().');
                        }
                        if (requestParameters['preferencesId'] == null) {
                            throw new runtime.RequiredError('preferencesId', 'Required parameter "preferencesId" was null or undefined when calling updateOutboundPreferences().');
                        }
                        if (requestParameters['outboundNotificationPreferencesUpdateDto'] == null) {
                            throw new runtime.RequiredError('outboundNotificationPreferencesUpdateDto', 'Required parameter "outboundNotificationPreferencesUpdateDto" was null or undefined when calling updateOutboundPreferences().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/outboundPreferences/organization/{organizationId}/preferences/{preferencesId}".replace("{".concat("organizationId", "}"), encodeURIComponent(String(requestParameters['organizationId']))).replace("{".concat("preferencesId", "}"), encodeURIComponent(String(requestParameters['preferencesId']))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.OutboundNotificationPreferencesUpdateDtoToJSON)(requestParameters['outboundNotificationPreferencesUpdateDto']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.OutboundNotificationPreferencesShowDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates preferences for a given organization, template key, and channel.
     */
    NotificationsApi.prototype.updateOutboundPreferences = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOutboundPreferencesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return NotificationsApi;
}(runtime.BaseAPI));
exports.NotificationsApi = NotificationsApi;
